module.exports = __webpack_public_path__ + "static/media/ic-training.2daf0389.svg";